import React from "react";
import {
  FeatherCheck,
  FeatherFileText,
  FeatherInfo,
  FeatherAlertTriangle,
  FeatherX,
} from "@subframe/core";
import { IconButton } from "../../../../ui/components/IconButton";
import { ChecklistItemEntity } from "../../domain/entities/ChecklistEntity";

interface TaskGuidancePanelProps {
  item: ChecklistItemEntity;
  onClose: () => void;
}

export const TaskGuidancePanel: React.FC<TaskGuidancePanelProps> = ({
  item,
  onClose,
}) => {
  return (
    <div className="flex w-80 flex-none flex-col items-start gap-6 self-stretch border-l border-solid border-neutral-border bg-default-background px-6 py-6 overflow-auto">
      {/* Header with close button */}
      <div className="flex w-full items-center justify-between">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Task Guidance
        </span>
        <IconButton
          variant="neutral-tertiary"
          size="small"
          icon={<FeatherX />}
          onClick={onClose}
        />
      </div>
      <div className="flex w-full flex-col items-start gap-4">
        <div className="flex flex-col items-start gap-2">
          <span className="text-body-bold font-body-bold text-default-font">
            {item.title}
          </span>
        </div>

        {/* What needs to be done */}
        {item.task_guidance && item.task_guidance.length > 0 && (
          <div className="flex w-full flex-col items-start gap-3">
            <span className="text-body-bold font-body-bold text-default-font">
              What needs to be done
            </span>
            <div className="flex w-full flex-col items-start gap-2">
              {item.task_guidance.map((guidance, index) => (
                <div key={index} className="flex items-start gap-2">
                  <FeatherCheck className="text-body font-body text-success-600 flex-shrink-0 mt-0.5" />
                  <span className="text-body font-body text-default-font">
                    {guidance}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-border" />

        {/* Accepted proof */}
        {/* {item.accepted_proof_types && item.accepted_proof_types.length > 0 && (
          <div className="flex w-full flex-col items-start gap-3">
            <span className="text-body-bold font-body-bold text-default-font">
              Accepted proof
            </span>
            <div className="flex w-full flex-col items-start gap-2">
              {item.accepted_proof_types.map((proofType, index) => (
                <div key={index} className="flex items-start gap-2">
                  <FeatherFileText className="text-body font-body text-neutral-600 flex-shrink-0 mt-0.5" />
                  <span className="text-body font-body text-default-font">
                    {proofType.charAt(0).toUpperCase() + proofType.slice(1)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )} */}

        <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-border" />

        {/* System info */}
        {item.system_info && (
          <div className="flex w-full flex-col items-start gap-3">
            <span className="text-body-bold font-body-bold text-default-font">
              System info
            </span>
            <div className="flex w-full flex-col items-start gap-2 rounded-md bg-neutral-100 px-3 py-3">
              {typeof item.system_info === "object" ? (
                Object.entries(item.system_info).map(([key, value]) => (
                  <div key={key} className="flex items-center gap-2">
                    {typeof value === "string" &&
                    (value.includes("error") ||
                      value.includes("warning") ||
                      value.includes("alert")) ? (
                      <FeatherAlertTriangle className="text-body font-body text-warning-600" />
                    ) : (
                      <FeatherInfo className="text-body font-body text-neutral-600" />
                    )}
                    <span className="text-caption font-caption text-subtext-color">
                      {key}: {String(value)}
                    </span>
                  </div>
                ))
              ) : (
                <div className="flex items-center gap-2">
                  <FeatherInfo className="text-body font-body text-neutral-600" />
                  <span className="text-caption font-caption text-subtext-color">
                    {String(item.system_info)}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
